import { UIRouter } from '@uirouter/angular';
// import { Visualizer } from '@uirouter/visualizer';
import { Injector } from '@angular/core';

export function configureRouterModule(router: UIRouter, injector: Injector) {
  router.urlService.rules.otherwise({state: '404'});

  // const pluginInstance = router.plugin(Visualizer);
}



// WEBPACK FOOTER //
// ./src/app/router.config.ts